import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { BaseEndpoint } from '../app.constants';
import { Headers, Http } from '@angular/http';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { CollateralSkillSet } from './collateralskillset.model';

@Injectable()
export class CollateralskillsetsService {
    @Output() requestAdded = new EventEmitter<any[]>();
    @Output() skillsetAdded = new EventEmitter<any>();
    @Output() skillsetUpdated = new EventEmitter<any>();
    @Output() skillsetDeleted = new EventEmitter<any>();
    private skillset: CollateralSkillSet[] = [];

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService) { }

    async getCollateralSkillsets() {
        const url = this.baseApiUrl + 'v1/skillsets';
        let header = await this.adalService.createServiceHeader();
        return this.http.get(url, { headers: header }).toPromise().then(resp => {
            return resp.json().body;
        }).catch(this.handleError);
    }

   async getProductSkillSet() {
        const url = this.baseApiUrl + 'v1/product/skillsets';
        let header = await this.adalService.createServiceHeader();
        return this.http.get(url, { headers: header }).toPromise().then(resp => {
            return resp.json().body;
        }).catch(this.handleError);
        
   }

    async addCollateralSkillset(skillset) {
        const url = this.baseApiUrl + 'v1/skillset';
        let header = await this.adalService.createServiceHeader();
        return this.http.post(url, JSON.stringify(skillset), { headers: header }).toPromise().then(resp => {
            const newSkillset = resp.json().body as CollateralSkillSet;
            this.skillsetAdded.emit(newSkillset);
            return newSkillset;
        }).catch(this.handleError);
    }

    updateSkillset(skillset: CollateralSkillSet): Promise<CollateralSkillSet> {
        const url = this.baseApiUrl + 'v1/skillset/update/' + skillset.id;
        return this.http
            .put(url, JSON.stringify(skillset), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;
                if (success) {
                    this.skillsetUpdated.emit(skillset);
                }
                return success;
            })
            .catch(resp => {
                var errors = resp.json().messages;
                if (errors)
                    return this.handleError(errors.map(({ description }) => description));
                else
                    return this.handleError(null);
            });
    }

    deleteSkillset(skillsetId: string): Promise<boolean> {
        var url = this.baseApiUrl + 'v1/skillset/delete/' + skillsetId;
        return this.http
            .delete(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;
                if (success) {
                    this.skillsetDeleted.emit(skillsetId);
                }
                return success;
            })
            .catch(this.handleError);
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/collateralskillsets.service.ts